import moduleDateFilter from '../reusablemodules/dateFilter'
import ACT, { workerCallCenterStatsACT as wACT } from '../../constants/vuexActions'
import apolloClient from '../../apolloClient'
import graphqlStats from '../../constants/graphqlStats'
import MUT from '../../constants/vuexMutations'
import ModuleWorkerFilter from '../reusablemodules/workerFilter'
import { cancelable } from 'cancelable-promise'

const moduleCallCenterWorkerStats = (workerPosition, page) => {
  let queryStats = workerPosition === 'call_center' ? graphqlStats.workerCallCenterStats : graphqlStats.cookerMotivateStats
  return {
    namespaced: true,
    state: {
      idWorker: null,
      groupByDay: false,
      workerStats: [],
      loadingQuery: false,
      queryPromises: []
    },
    actions: {
      [ACT.GROUP_BY_DAY_UPDATED]: ({commit, dispatch, state}, group) => {
        commit(MUT.SET_GROUP_BY_DAY, group)
        dispatch(ACT.GET_WORKERS_STATS)
      },
      [ACT.DATE_UPDATED]: ({commit, dispatch, state}) => {
        dispatch(ACT.GET_WORKERS_STATS)
      },
      [ACT.WORKER_UPDATED]: ({commit, dispatch, state}) => {
        dispatch(ACT.GET_WORKERS_STATS)
      },
      [ACT.GET_WORKERS_STATS]: async ({state, commit, dispatch, getters}) => {
        try {
          if (state.workerFilter.workers.length === 0 && page === 'stats') {
            await dispatch(ACT.GET_WORKERS)
          }
        } catch (e) {
          console.error(e)
        }
        commit(MUT.SET_LOADING_STATE, true)
        let promise = apolloClient.query({
          query: queryStats,
          variables: {
            dateFrom: getters.dateFromForQuery,
            dateTo: getters.dateToForQuery,
            idWorker: getters.selectedWorkerQuery ? getters.selectedWorkerQuery : null
          }
        })
        for (let i = 0; i < state.queryPromises.length; i++) {
          state.queryPromises[i].cancel()
        }
        let cancelablePromise = cancelable(promise)
        state.queryPromises.push(cancelablePromise)
        cancelablePromise.then(res => {
          let result = null
          if (workerPosition === 'call_center') {
            result = res.data.statsWorkerCallcenter.nodes
          } else if (workerPosition === 'cooker') {
            result = res.data.calcCookerMotivate.nodes
          }
          commit(MUT.SET_LOADING_STATE, false)
          commit(MUT.SET_STATS_WORKER, result)
        }).catch(err => {
          alert(err)
          commit(MUT.SET_LOADING_STATE, false)
        })
        return cancelablePromise
      }
    },
    mutations: {
      [MUT.SET_STATS_WORKER]: (state, payload) => {
        state.workerStats = payload
      },
      [MUT.SET_LOADING_STATE]: (state, payload) => {
        state.loadingQuery = payload
      },
      [MUT.SET_GROUP_BY_DAY]: (state, payload) => {
        state.groupByDay = payload
      }
    },
    getters: {
      workerStatsTable (state, getters) {
        let rowsStats = []
        if (workerPosition === 'call_center') {
          let orderId = 0;
          let currentDate = '0001-01-01';
          let statDay = {
            date: null,
            orderSum: 0.0,
            orderCount: 0,
            price: 0.0,
            priceMotivate: 0.0,
            motivateProducts: 0,
            total: 0.0
          };
          state.workerStats.forEach((stat) => {
            // результат запроса (функции) отсортирован по датам и id заказа
            if (currentDate !== stat.date) {
              if ('0001-01-01' === currentDate) {
                // первый элемент массива state.workerStats
                statDay.date = new Date(stat.date);
              } else {
                // последующие дни
                statDay.total = statDay.price + statDay.priceMotivate;
                rowsStats.push(statDay);
                statDay = {
                  date: new Date(stat.date),
                  orderSum: 0.0,
                  orderCount: 0,
                  price: 0.0,
                  priceMotivate: 0.0,
                  motivateProducts: 0,
                  total: 0.0
                };
              }
              
              currentDate = stat.date;
            }
            
            if (orderId !== stat.idOrder) {
              // Администраторам идет процент от всего чека (1%), который они приняли.
              // Операторам идет процент от всего чека (1%), который они приняли, и 10 рублей за заказ.
              orderId = stat.idOrder;
              let orderSum = parseFloat(stat.orderSum);
              statDay.orderSum += orderSum;
              statDay.orderCount += 1;
              statDay.price += orderSum * 0.01 + (stat.isRestManager ? 0 : 10);
            }
            
            let priceMotivate = parseFloat(stat.priceMotivate);
            if (priceMotivate > 0.0 && stat.isRestManager) {
              statDay.motivateProducts += stat.productCount;
              statDay.priceMotivate += parseFloat(stat.priceMotivate) * stat.productCount;
            }
          });
          
          if (null !== statDay.date) {
            // последний день в статистике
            statDay.total = statDay.price + statDay.priceMotivate;
            rowsStats.push(statDay);
          }
        } else if (workerPosition === 'cooker') {
          state.workerStats.forEach((stat) => {
            let statObj = {
              restPoint: stat.restPoint,
              date: stat.date,
              timeOpened: stat.timeOpened,
              timeClosed: stat.timeClosed,
              hoursOnWork: Number(stat.hoursOnWork),
              sumFromHours: Number(stat.sumFromHours),
              percentTarget: Number(stat.percentTarget),
              percentReward: Number(stat.percentReward),
              sumPercentageOfTurnover: Number(stat.sumPercentageOfTurnover),
              turnover: Number(stat.turnover),
              hour: stat.hour,
              totalWorkersHoursByPointDay: stat.totalWorkersHoursByPointDay,
              secondsOnWork: stat.secondsOnWork
            }
            statObj.total = statObj.sumFromHours + statObj.sumPercentageOfTurnover
            rowsStats.push(statObj)
          })

          let finalObj = {}
          if (getters.groupByDay) {
            let sumFromHours = 0
            let percentTarget = 0
            let percentReward = 0
            let sumPercentageOfTurnover = 0
            let turnover = 0
            let totalWorkersHoursByPointDay = 0
            rowsStats.forEach((el, index) => {
              const date = el.timeOpened
              if (finalObj[date]) {
                sumFromHours += el.sumFromHours
                percentTarget += el.percentTarget
                percentReward += el.percentReward
                sumPercentageOfTurnover += el.sumPercentageOfTurnover
                turnover += el.turnover
                totalWorkersHoursByPointDay += el.totalWorkersHoursByPointDay

                finalObj[date].sumFromHours = sumFromHours
                finalObj[date].percentTarget = percentTarget
                finalObj[date].percentReward = percentReward
                finalObj[date].sumPercentageOfTurnover = sumPercentageOfTurnover
                finalObj[date].turnover = turnover
                finalObj[date].totalWorkersHoursByPointDay = totalWorkersHoursByPointDay
              } else {
                sumFromHours = el.sumFromHours
                percentTarget = el.percentTarget
                percentReward = el.percentReward
                sumPercentageOfTurnover = el.sumPercentageOfTurnover
                turnover = el.turnover
                totalWorkersHoursByPointDay = el.totalWorkersHoursByPointDay

                finalObj[date] = el
              }
            })
            rowsStats = []
            for (let key in finalObj) {
              let groupItem = finalObj[key]
              const timeOpened = new Date(groupItem.timeOpened)
              const timeClosed = new Date(groupItem.timeClosed)
              groupItem.secondsOnWork = (timeClosed - timeOpened) / 1000
              let statObj = {
                restPoint: groupItem.restPoint,
                date: groupItem.date,
                timeOpened: groupItem.timeOpened,
                timeClosed: groupItem.timeClosed,
                hoursOnWork: Number(groupItem.secondsOnWork / 3600),
                sumFromHours: Number(groupItem.sumFromHours),
                percentTarget: Number(groupItem.percentTarget),
                percentReward: Number(groupItem.percentReward),
                sumPercentageOfTurnover: Number(groupItem.sumPercentageOfTurnover),
                turnover: Number(groupItem.turnover),
                hour: groupItem.hour,
                totalWorkersHoursByPointDay: groupItem.totalWorkersHoursByPointDay,
                secondsOnWork: groupItem.secondsOnWork
              }
              statObj.total = statObj.sumFromHours + statObj.sumPercentageOfTurnover
              rowsStats.push(statObj)
            }
          }
        }
        return rowsStats
      },
      workerStatsSummary (state, getters) {
        let summary = null
        if (workerPosition === 'call_center') {
          summary = {
            orderSum: 0,
            orderCount: 0,
            price: 0,
            priceMotivate: 0,
            motivateProducts: 0,
            total: 0
          }
          getters.workerStatsTable.forEach(stat => {
            summary.orderSum += stat.orderSum
            summary.orderCount += stat.orderCount
            summary.price += stat.price
            summary.priceMotivate += stat.priceMotivate
            summary.motivateProducts += stat.motivateProducts
            summary.total += stat.total
          })
        } else if (workerPosition === 'cooker') {
          summary = {
            hoursOnWork: 0,
            secondsOnWork: 0,
            sumFromHours: 0,
            sumPercentageOfTurnover: 0,
            turnover: 0,
            total: 0
          }
          getters.workerStatsTable.forEach(stat => {
            summary.secondsOnWork += stat.secondsOnWork
            summary.sumFromHours += stat.sumFromHours
            summary.sumPercentageOfTurnover += stat.sumPercentageOfTurnover
            summary.turnover += stat.turnover
            summary.total += stat.total
          })
          summary.hoursOnWork = summary.secondsOnWork / 3600
        }
        return summary
      },
      groupByDay (state) {
        return state.groupByDay ? state.groupByDay : false
      }
    },
    modules: {
      dateFilter: moduleDateFilter,
      workerFilter: (new ModuleWorkerFilter(workerPosition)).staticModule()
    }
  }
}

export default moduleCallCenterWorkerStats



// WEBPACK FOOTER //
// ./src/vuex/submodules/motivateWorkerStats.js